import type { DispositionCode } from '@kunzite/shared-types';
import { useEffect, useState } from 'react';

import { useWidgetServices } from '../../services/services-context';

export interface UseDispositionCodesResult {
  codes: DispositionCode[];
  version: number;
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useDispositionCodes(): UseDispositionCodesResult {
  const services = useWidgetServices();
  const [codes, setCodes] = useState<DispositionCode[]>([]);
  const [version, setVersion] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = async (): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      const r = await services.tenants.getSettings();
      setCodes(r.settings.dispositionCodes ?? []);
      setVersion(r.version);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setCodes([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void load();
  }, []);

  return { codes, version, loading, error, refetch: load };
}
